import type { SVGProps } from 'react';

const SvgDeletionClear = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 3a9 9 0 1 0 .001 18.001A9 9 0 0 0 12 3m3.83 12.59c-.2.2-.45.29-.71.29s-.51-.1-.71-.29l-2.29-2.29-2.41 2.41c-.2.2-.45.29-.71.29s-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l2.41-2.41L8.41 9.6a.996.996 0 1 1 1.41-1.41l2.29 2.29 2.17-2.17a.996.996 0 1 1 1.41 1.41l-2.17 2.17 2.29 2.29c.39.39.39 1.02 0 1.41z"
    />
  </svg>
);
export default SvgDeletionClear;
